import React, { Component } from "react";
import {Icon, Rate} from 'antd'


const {Link} = require("react-router")


class TpOrderListView extends Component {

    constructor(props) {
        super(props)
        this.location = {
            "resort_name": "253 Mancreek Resort",
            "address_line1": " 253 scottland av",
            "county": "albanyt",
            "postalcode": 12193,
            "market_code": "NAMER",
            "country": "usa",
            "region_desc_en": [
                "United States",
                "Coastal Mid Atlantic"
            ],
            "state": "NY",
        }
    }
    render() {
        const ars = [];
        let svrstars = {
            "sv_rating_no": 5,
            "color": "#e8a01899"
        }
        console.log('############### this.props.svrlocation ****************')
        console.log(this.props.svrlocation)

        let svcolor =  (this.props.isRefund ===true) ? '#ff4d4d': '#000000'
        console.log('sv****** FEB28********svcolor', svcolor)



        return (

      
        
          
               <div>

                    <p className="m-para-text">
                                <span style={{fontSize: "14px"}} > <Icon  style={{ fontSize:'18px', color: 'rgb(55, 173, 219)' }} type="dashboard" theme="filled" /><text style={{color:'#cc8e3b', fontSze:'16px',  paddingLeft: "10px", paddingRight:'20px'}}>{this.props.svrlocation.flight_departure_time} {this.props.svrlocation.flight_departure_daytime}</text><Icon type="line" /><text style={{ color: '#122196' }} style={{color:'#cc8e3b', fontSze:'16px', paddingLeft: "20px"}}>{this.props.svrlocation.flight_arrival_time} {this.props.svrlocation.flight_arrival_daytime}</text></span>
                                    
                                    <text style={{fontSize:'14px'}} className="svr-hotel-room d-block" >  {this.props.svrlocation.origincity}  ({this.props.svrlocation.origin_airport_code}) - {this.props.svrlocation.destcity} ({this.props.svrlocation.dst_airport_code}) </text>
                                    <span style={{fontSize: "14px"}} > <Icon  style={{ color: '#ca61a1', opacity:'0.9', fontSize:'16px' }} type="account-book" theme="filled" /><text style={{paddingLeft: "10px", color:'#898995'}}>{this.props.svrlocation.airlines_name}</text></span>
            
                 </p>
               
                <p className="m-para-text-first" style={{paddingTop:"10px"}}>
                    <span> 
                        <text className="svr-hotel-name"  style={{fontSize:"1.5.em", paddingRight:"10px",color:"rgb(208,156,31)"}}>{this.props.svrlocation.org_aiport_csc_addr}</text>
        
                        <Icon  style={{ color:"rgb(215, 125, 10)" , fontSize:"20px" }} type="slack-square" theme="filled" />
                    </span>
                    
                    
                    <span className="ter-l2 svr-hotel-location" style={{marginTop:"0px", marginBottom:"0px"}}>
                        <text style={{fontSize:"15px", color:"rgb(132, 115, 97)", fontWeight:"400", paddingRight:"15px"}}>
                       {this.props.svrlocation['org_aiport_csc_addr']}
                        </text>
                        <Icon  style={{ color: "rgb(7, 115, 29)", fontSize:"20px" }} type="environment" theme="filled" />
                        <text style={{fontSize:"16px", color:"rgb(18, 85, 219)", paddingLeft:"10px",fontWeight:"420"}}>Excellent2 {this.props.svrlocation['flight_space_key']}- Shown On MapSV</text> 
                    </span>
                        
                   
                    <p style={{color:svcolor}}>
                        <dl>
                            <dt className="tax-ib-info"><span className="nh"><text className="tax-line"> Airlines Booking Status</text></span></dt>
                            <dd className="tax-ib-amt"><span className="n2">{this.props.svrlocation['hostMessage']} </span> </dd>
                        </dl>
                        <dl>
                            <dt className="tax-ib-info"><span className="nh"><text className="tax-line"> Card Confirmation (transactionId)</text></span></dt>
                            <dd className="tax-ib-amt"><span className="n2">{this.props.svrlocation['transactionId']} </span> </dd>
                        </dl>


                        <dl>
                            <dt className="tax-ib-info"><span className="nh"><text className="tax-line"> Stay(StartDate-EndDate)</text></span></dt>
                            <dd className="tax-ib-amt"><span className="n2">{this.props.svrlocation['endDate']} - {this.props.svrlocation['startDate']}</span> </dd>
                        </dl>
                        <dl>
                            <dt className="tax-ib-info"><span className="nh"><text className="tax-line"> Order Status</text></span></dt>
                            <dd className="tax-ib-amt"><span className="n2">{this.props.svrlocation['orderItemStatusCode']}</span> </dd>
                        </dl>
                        <dl>
                            <dt className="tax-ib-info"><span className="nh"><text className="tax-line"> Order Date</text></span></dt>
                            <dd className="tax-ib-amt"><span className="n2">{this.props.svrlocation['createdDate']}</span> </dd>
                        </dl>
                        <dl>
                            <dt className="tax-ib-info"><span className="nh"><text className="tax-line"> Order Id</text></span></dt>
                            <dd className="tax-ib-amt"><span className="n2"> {this.props.svrlocation['orderId']}</span> </dd>
                        </dl>
                        <dl>
                            <dt className="tax-ib-info"><span className="nh"><text className="tax-line"> Product Id</text></span></dt>
                            <dd className="tax-ib-amt"><span className="n2"> {this.props.svrlocation['productId']}</span> </dd>
                        </dl>
                    
                        <dl>
                            <dt className="tax-ib-info"><span className="nh"><text className="tax-line"> Address Id</text></span></dt>
                            <dd className="tax-ib-amt"><span className="n2"> {this.props.svrlocation['addressId']}</span> </dd>
                        </dl>

                        <dl>
                            <dt className="tax-ib-info"><span className="nh"><text className="tax-line"> Passengers</text></span></dt>
                            <dd className="tax-ib-amt"><span className="n2"> 2 Adults </span> </dd>
                        </dl>
                    
                        <dl>
                            <dt className="tax-ib-info"><span className="nh"><text className="tax-line"> Rservation Code</text></span></dt>
                            <dd className="tax-ib-amt"><span className="n2">{this.props.svrlocation['reservationConfirmCode']}</span> </dd>
                        </dl>
                        <dl>
                            <dt className="tax-ib-info"><span className="nh"><text className="tax-line"> Order Total</text></span></dt>
                            <dd className="tax-ib-amt"><span className="n2">${this.props.svrlocation['salePrice']}</span> </dd>
                        </dl>
                    </p>
                </p>
                
                </div>
          
        )
    }

}

export default TpOrderListView;